import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { RenderAmenityBody } from './render-amenity-helper';

interface PropertyPoliciesSectionProps {
  id: string;
  model: any;
  titleLocToken: string;
  secondaryTitleClassNames: string;
}

export const PropertyPoliciesSection: React.FunctionComponent<PropertyPoliciesSectionProps> = ({
  id,
  model,
  titleLocToken,
  secondaryTitleClassNames
}) => {
  const showSection = Boolean(model && model.lines && model.lines.length > 0);

  if (!showSection) {
    return null;
  }

  const divClassName = `${id} all-y-padding-three`;
  const titleString = `${id}__title`;
  const titleClasses = `${titleString} ${secondaryTitleClassNames}`;
  const category = `${id}__details`;

  return (
    <div className={divClassName}>
      <h3 data-stid={titleString} className={titleClasses}>
        <LocalizedText message={titleLocToken} />
      </h3>
      {model.lines.map((text, index) => (
        <RenderAmenityBody text={text} index={index} category={category} />
      ))}
    </div>
  );
};
